import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import {ApiService} from "../api.service";
import {Router} from "@angular/router";

declare var jquery:any;
declare var $ :any;


@Component({
    selector: 'app-hr-report-overview',
    templateUrl: './hr-report-overview.component.html',
    styleUrls: ['./hr-report-overview.component.css']
})
export class HrReportOverviewComponent implements OnInit, AfterViewInit {
    personalReportListSelected: boolean
    coachSelected: boolean;
    selectedAbilityIndex: number;

    users: any;

    companyReport: any;

    constructor(private apiService: ApiService, private router: Router) { }

    ngOnInit() {
        this.personalReportListSelected = true;
        this.coachSelected = true;

        this.getPersons();
        /*this.users= [
            {
                "name":"陈玉华",
                "department":"CFD部门",
                "title":"总经理"
            },
            {
                "name":"陈玉华",
                "department":"CFD部门",
                "title":"总经理"
            },
            {
                "name":"陈玉华",
                "department":"CFD部门",
                "title":"总经理"
            },
            {
                "name":"陈玉华",
                "department":"CFD部门",
                "title":"总经理"
            }
        ];

        this.companyReport={
            "users":[
                {"name":"余志军🏝","status":"未完成","level":""},
                {"name":"康康先生","status":"未完成","level":""},
                {"name":"Ting💢","status":"未完成","level":""},
                {"name":"希昔茜","status":"未完成","level":""},
                {"name":"roman_timeout","status":"未完成","level":""},
                {"name":"骆应罗","status":"未完成","level":""},
                {"name":"Sky","status":"未完成","level":""}
                ],
            "preSurveyAvg":2,
            "postSurveyAvg":6,
            "userKas":[
                {"name":"余志军🏝","bestKaName":"提供支持","bestKaLevel":4,"worstKaName":"制定行动计划 ","worstKaLevel":1},
                {"name":"康康先生","bestKaName":"说明讨论的目的","bestKaLevel":5,"worstKaName":"明确表达绩效挑战","worstKaLevel":1},
                {"name":"Ting💢","bestKaName":"明确表达绩效挑战","bestKaLevel":7,"worstKaName":"维持动力","worstKaLevel":1},
                {"name":"希昔茜","bestKaName":"制定行动计划 ","bestKaLevel":5,"worstKaName":"制定行动计划 ","worstKaLevel":1}
                ]
        };*/
    }

    ngAfterViewInit(){
        document.documentElement.style.backgroundColor="#3d3d6e";
        let htmlFontSize;
        if(window.screen.width<window.screen.height){
            htmlFontSize = window.screen.width/ 7.5;
        }else{
            htmlFontSize = window.screen.height/ 7.5;
        }
        document.documentElement.style.fontSize=htmlFontSize+"px";

    }

    selectReportList(bool:boolean){
        this.personalReportListSelected = bool;

        if (!bool) {
            if (!this.companyReport) {
                this.apiService.getCompanyReport().subscribe(result => {
                    this.companyReport = result;
                    this.selectedAbilityIndex = 0;
                });
            }
        }
    }

    selectAbility(index:number){
      this.selectedAbilityIndex = index;
    }

    showDetailReport(userId: any) {
        let link = ['graduation', 0, userId,0];
        this.router.navigate(link);
    }

    getPersons() {
        this.apiService.getHrReports().subscribe(result => {
            this.users = result;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/hr-report-overview/hr-report-overview.component.ts